import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAll = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1808 23.293C21.1808 25.5413 18.7807 27.3639 15.8199 27.3639C12.8592 27.3639 10.459 25.5413 10.459 23.293C10.459 21.0448 12.8592 19.2222 15.8199 19.2222C18.7807 19.2222 21.1808 21.0448 21.1808 23.293Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.7817 27.7135C19.4451 28.7284 17.6844 29.3 15.82 29.3C13.9555 29.3 12.1948 28.7284 10.8582 27.7135C9.52021 26.6975 8.52271 25.1528 8.52271 23.2928C8.52271 21.4329 9.52021 19.8882 10.8582 18.8722C12.1948 17.8572 13.9555 17.2856 15.82 17.2856C17.6844 17.2856 19.4451 17.8572 20.7817 18.8722C22.1197 19.8882 23.1172 21.4329 23.1172 23.2928C23.1172 25.1528 22.1197 26.6975 20.7817 27.7135ZM15.82 27.3637C18.7807 27.3637 21.1809 25.5411 21.1809 23.2928C21.1809 21.0446 18.7807 19.222 15.82 19.222C12.8592 19.222 10.459 21.0446 10.459 23.2928C10.459 25.5411 12.8592 27.3637 15.82 27.3637Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1808 19.222C21.1808 21.4702 18.7807 23.2928 15.8199 23.2928C12.8592 23.2928 10.459 21.4702 10.459 19.222C10.459 16.9737 12.8592 15.1511 15.8199 15.1511C18.7807 15.1511 21.1808 16.9737 21.1808 19.222Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.7817 23.6427C19.4451 24.6576 17.6844 25.2292 15.82 25.2292C13.9555 25.2292 12.1948 24.6576 10.8582 23.6427C9.52021 22.6267 8.52271 21.082 8.52271 19.222C8.52271 17.3621 9.52021 15.8174 10.8582 14.8014C12.1948 13.7864 13.9555 13.2148 15.82 13.2148C17.6844 13.2148 19.4451 13.7864 20.7817 14.8014C22.1197 15.8174 23.1172 17.3621 23.1172 19.222C23.1172 21.082 22.1197 22.6267 20.7817 23.6427ZM15.82 23.2929C18.7807 23.2929 21.1809 21.4703 21.1809 19.222C21.1809 16.9738 18.7807 15.1512 15.82 15.1512C12.8592 15.1512 10.459 16.9738 10.459 19.222C10.459 21.4703 12.8592 23.2929 15.82 23.2929Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7176 26.3187C29.7176 28.5669 27.3174 30.3895 24.3566 30.3895C21.3959 30.3895 18.9957 28.5669 18.9957 26.3187C18.9957 24.0704 21.3959 22.2478 24.3566 22.2478C27.3174 22.2478 29.7176 24.0704 29.7176 26.3187Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.3185 30.7394C27.9819 31.7543 26.2212 32.3259 24.3567 32.3259C22.4922 32.3259 20.7315 31.7543 19.3949 30.7394C18.057 29.7233 17.0594 28.1787 17.0594 26.3187C17.0594 24.4588 18.057 22.9141 19.3949 21.8981C20.7315 20.8831 22.4922 20.3115 24.3567 20.3115C26.2212 20.3115 27.9819 20.8831 29.3185 21.8981C30.6565 22.9141 31.654 24.4588 31.654 26.3187C31.654 28.1787 30.6565 29.7233 29.3185 30.7394ZM24.3567 30.3896C27.3175 30.3896 29.7176 28.567 29.7176 26.3187C29.7176 24.0704 27.3175 22.2479 24.3567 22.2479C21.396 22.2479 18.9958 24.0704 18.9958 26.3187C18.9958 28.567 21.396 30.3896 24.3567 30.3896Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1808 14.4063C21.1808 16.6546 18.7807 18.4772 15.8199 18.4772C12.8592 18.4772 10.459 16.6546 10.459 14.4063C10.459 12.158 12.8592 10.3354 15.8199 10.3354C18.7807 10.3354 21.1808 12.158 21.1808 14.4063Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.7817 18.827C19.4451 19.842 17.6844 20.4136 15.82 20.4136C13.9555 20.4136 12.1948 19.842 10.8582 18.827C9.52021 17.811 8.52271 16.2663 8.52271 14.4064C8.52271 12.5464 9.52021 11.0017 10.8582 9.98572C12.1948 8.97076 13.9555 8.39917 15.82 8.39917C17.6844 8.39917 19.4451 8.97076 20.7817 9.98572C22.1197 11.0017 23.1172 12.5464 23.1172 14.4064C23.1172 16.2663 22.1197 17.811 20.7817 18.827ZM15.82 18.4772C18.7807 18.4772 21.1809 16.6546 21.1809 14.4064C21.1809 12.1581 18.7807 10.3355 15.82 10.3355C12.8592 10.3355 10.459 12.1581 10.459 14.4064C10.459 16.6546 12.8592 18.4772 15.82 18.4772Z",
			fill: "#262626"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.7176 21.5032C29.7176 23.7515 27.3174 25.5741 24.3566 25.5741C21.3959 25.5741 18.9957 23.7515 18.9957 21.5032C18.9957 19.255 21.3959 17.4324 24.3566 17.4324C27.3174 17.4324 29.7176 19.255 29.7176 21.5032Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.3185 25.9237C27.9819 26.9386 26.2212 27.5102 24.3567 27.5102C22.4922 27.5102 20.7315 26.9386 19.3949 25.9237C18.057 24.9077 17.0594 23.363 17.0594 21.503C17.0594 19.6431 18.057 18.0984 19.3949 17.0824C20.7315 16.0674 22.4922 15.4958 24.3567 15.4958C26.2212 15.4958 27.9819 16.0674 29.3185 17.0824C30.6565 18.0984 31.654 19.6431 31.654 21.503C31.654 23.363 30.6565 24.9077 29.3185 25.9237ZM24.3567 25.5739C27.3175 25.5739 29.7176 23.7513 29.7176 21.503C29.7176 19.2548 27.3175 17.4322 24.3567 17.4322C21.396 17.4322 18.9958 19.2548 18.9958 21.503C18.9958 23.7513 21.396 25.5739 24.3567 25.5739Z",
			fill: "#262626"
		})
	]
});
const ForwardRef = forwardRef(SvgAll);
export default ForwardRef;
